import React, { Component } from "react"
import { GridProps } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledH4 = styled.h4`
  margin-right: 1.75rem;
  margin-bottom: 0;
  font-weight: bold;
`;

class HomeLeftHeaderTitle extends Component<GridProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <StyledH4 {...rest}>
          {children}
        </StyledH4>
    )
  }
}

export default HomeLeftHeaderTitle;
